module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/search-section-dd396753b77dbdfb2419694bd00901a9.png";